import { render, staticRenderFns } from "./ProductVariantImageUpload.vue?vue&type=template&id=1f432df0&scoped=true"
import script from "./ProductVariantImageUpload.vue?vue&type=script&lang=js"
export * from "./ProductVariantImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantImageUpload.vue?vue&type=style&index=0&id=1f432df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f432df0",
  null
  
)

export default component.exports